/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactDOM from 'react-dom';
import Model from '@tripian/model';
import React, { useState } from 'react';
import Button from '../base/Button/Button';
import CloseIconButton from '../base/Button/Icons/CloseIconButton/CloseIconButton';
import Dropdown from '../base/Dropdown/Dropdown';
import PreLoading from '../base/PreLoading/PreLoading';
import classes from './Feedback.scss';

interface IFeedback {
  feedbackSubjects: Model.FeedbackSubjects[];
  sendFeedback: (value: Model.FeedbackRequest) => Promise<void>;
  showModal?: boolean;
  setShowModal?: () => void;
  t: (value: Model.TranslationKey) => string;
}

const Feedback: React.FC<IFeedback> = ({ feedbackSubjects, sendFeedback, showModal = true, setShowModal, t }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [feedback, setFeedBack] = useState<Model.FeedbackRequest>(() => ({
    subjectType: feedbackSubjects?.[0]?.subjectType ?? 'main',
    subjectId: feedbackSubjects?.[0]?.id ?? 0,
    desc: '',
  }));

  // Don't render if no feedback subjects available
  if (!feedbackSubjects || feedbackSubjects.length === 0) {
    return null;
  }

  const handleChange = (id: string | number) => {
    const selectedSubject = feedbackSubjects.find((subject) => subject.id === Number(id));

    if (selectedSubject) setFeedBack({ ...feedback, subjectId: selectedSubject.id });
  };

  const setFeedbackDefault = () => {
    setFeedBack({ ...feedback, subjectId: feedbackSubjects[0].id, desc: '' });
  };

  const options = feedbackSubjects.map((subject) => ({
    value: subject.id,
    label: subject.title,
  }));

  // const numbersAndLettersOnly = (input: string) => {
  //   const inputRegex = RegExp('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$');

  //   const escapeRegExp = (string: string): string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  //   if (input === '' || inputRegex.test(escapeRegExp(input))) {
  //     setFeedBack({ ...feedback, desc: input.trimStart() });
  //   }
  // };

  if (setShowModal === undefined) {
    return (
      <div>
        <div className="row m0">
          <div className="col col12 p5 m0">
            {loading ? (
              <div className={classes.feedbackLoading}>
                <PreLoading />
              </div>
            ) : (
              <>
                <div className="col col12">
                  <h6 className="mt8 mb4">{t('support.feedback.modal.title')}</h6>
                  <Dropdown defaultValue={feedbackSubjects[0].title} options={options} selectChange={handleChange} skippable={false} />
                </div>
                <div className="col col12">
                  <h6 className="mt8 mb4">{t('support.feedback.modal.messageTitle')}</h6>
                  <textarea
                    name="problem"
                    rows={5}
                    className={classes.feedbackDesc}
                    value={feedback.desc}
                    onChange={(event) => {
                      setFeedBack({ ...feedback, desc: event.target.value });
                      // numbersAndLettersOnly(event.target.value);
                    }}
                  />
                </div>
                <div className="row m0 center">
                  <div className="col col6 my2">
                    <Button
                      color="primary"
                      text={t('support.feedback.modal.close')}
                      onClick={() => {
                        setFeedbackDefault();
                      }}
                    />
                  </div>
                  <div className="col col6 my2">
                    <Button
                      color="primary"
                      text={t('support.feedback.modal.send')}
                      onClick={() => {
                        setLoading(true);
                        sendFeedback(feedback).finally(() => {
                          setLoading(false);
                          setFeedbackDefault();
                        });
                      }}
                      disabled={feedback.desc.trim() === ''}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return ReactDOM.createPortal(
    <div className={classes.feedbackModal} style={{ display: showModal ? 'flex' : 'none' }}>
      <button
        className={classes.backdrop}
        onClick={() => setShowModal()}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setShowModal();
          }
        }}
        type="button"
        aria-label="Close modal"
      />
      <div className={classes.dialog}>
        <div className="flex items-center justify-between w-full md:mb-6 mb-4">
          <div className="text-2xl font-semibold text-neutral-800">Report a Problem</div>
          <CloseIconButton
            className="w-6 h-6"
            fill="#2B2B33"
            clicked={() => {
              setShowModal();
              setFeedbackDefault();
            }}
          />
        </div>

        {loading ? (
          <div className={classes.feedbackLoading}>
            <PreLoading />
          </div>
        ) : (
          <>
            <div className="col col12">
              <h6 className={classes.feedbackTitle}>{t('support.feedback.modal.title')}</h6>
              <Dropdown defaultValue={feedbackSubjects[0].title} options={options} selectChange={handleChange} skippable={false} />
            </div>
            <div className="col col12">
              <h6 className={classes.feedbackTitle}>{t('support.feedback.modal.messageTitle')}</h6>
              <textarea
                name="problem"
                rows={5}
                className={classes.feedbackDesc}
                value={feedback.desc}
                onChange={(event) => {
                  setFeedBack({ ...feedback, desc: event.target.value });
                }}
              />
            </div>
            <div className="row m0 center">
              <div className="col col12 my2 p0">
                <Button
                  color="primary"
                  className={classes.feedbackButton}
                  text={t('support.feedback.modal.send')}
                  onClick={() => {
                    setLoading(true);
                    sendFeedback(feedback).finally(() => {
                      setLoading(false);
                      setFeedbackDefault();
                    });
                  }}
                  disabled={feedback.desc.trim() === ''}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>,
    document.getElementById('modal-root') || document.body,
  );
};

export default Feedback;
